module.exports = __webpack_public_path__ + "img/vers로고.c05add82.png";